import { Box, SxProps, styled } from "@mui/material";

const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
}));

const Spinner = styled(Box)(({ theme }) => ({
  display: "block",
  position: "relative",
  width: theme.spacing(16),
  height: theme.spacing(16),
  borderRadius: "50%",
  border: `${theme.spacing(1)} solid transparent`,
  borderTop: `${theme.spacing(1)} solid ${theme.palette.dsPrimary.v200}`,
  animation: "spin 1.5s linear infinite",
  "&::after": {
    content: '" "',
    position: "absolute",
    borderRadius: "50%",
    border: `${theme.spacing(1)} solid transparent`,
    top: theme.spacing(0.5),
    left: theme.spacing(0.5),
    right: theme.spacing(0.5),
    bottom: theme.spacing(0.5),
    borderTopColor: theme.palette.dsPrimary.v200,
    animation: "spin 1s linear infinite",
  },
  "&::before": {
    content: '" "',
    position: "absolute",
    borderRadius: "50%",
    border: `${theme.spacing(1)} solid transparent`,
    top: theme.spacing(2),
    left: theme.spacing(2),
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    borderTopColor: theme.palette.dsPrimary.v200,
    animation: "spin 3.25s linear infinite",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));

interface ICustomSpinner {
  className?: SxProps;
}

const CustomSpinner = ({ className }: ICustomSpinner) => (
  <Container>
    <Spinner sx={className} />
    {/* <CircularProgress /> */}
  </Container>
);

export default CustomSpinner;
